import * as actionTypes from "../types/types";

export const updateSearchQuery = (query) => {
  return {
    type: actionTypes.UPDATE_SEARCH_QUERY,
    payload: query,
  };
};

export const addIngredient = (ingredient) => {
  return {
    type: actionTypes.ADD_INGREDIENT,
    payload: ingredient,
  };
};

export const removeIngredient = (ingredient) => {
  return {
    type: actionTypes.REMOVE_INGREDIENT,
    payload: ingredient,
  };
};

export const setIngredientError = (errorType, isError) => {
  return {
    type: actionTypes.SET_INGREDIENT_ERROR,
    payload: { errorType, isError },
  };
};

export const setInputValue = (value) => {
  return {
    type: actionTypes.SET_INPUT_VALUE,
    payload: value,
  };
};

export const openPopupAction = () => {
  return {
    type: actionTypes.OPEN_POPUP,
  };
};

export const closePopupAction = () => {
  return {
    type: actionTypes.CLOSE_POPUP,
  };
};

export const setSelectedRecipeAction = (recipe) => {
  return {
    type: actionTypes.SET_SELECTED_RECIPE,
    payload: recipe,
  };
};

export const fetchRecipesStartAction = () => {
  return {
    type: actionTypes.FETCH_RECIPES_START,
  };
};

export const fetchRecipesSuccessAction = (recipes) => {
  return {
    type: actionTypes.FETCH_RECIPES_SUCCESS,
    payload: recipes,
  };
};

export const fetchRecipesFailureAction = (error) => {
  return {
    type: actionTypes.FETCH_RECIPES_FAILURE,
    payload: error,
  };
};

export const toggleSearchButton = () => {
  return {
    type: actionTypes.TOGGLE_SEARCH_BUTTON,
  };
};
export const setNextPageUrlAction = (url) => ({
  type: actionTypes.SET_NEXT_PAGE_URL,
  payload: url,
});

